import React, { useMemo } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from 'react-router-dom';

import { useAppSelector } from '../store';

import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import CadastrosUsuario from '../pages/Cadastros/Usuarios';
import CadastrosOcorrencia from '../pages/Cadastros/Ocorrencias';
import CadastrosNotas from '../pages/Cadastros/Notas';
import RelatoriosEntregas from '../pages/Relatorios/Entregas';
import Documentacao from '../pages/Documentacao';
import NotFound from '../pages/NotFound';
import Layout from '../components/Layout';
import Loading from '../components/interface/Loading';
import Dialog from '../components/interface/Dialog';
import RelatoriosEntregadoresContainer from '../pages/Relatorios/Entregadores';
const ProtectedRoute = ({ children }: { children: React.ReactElement }) => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const ProtectedAdminRoute = ({
  children,
}: {
  children: React.ReactElement;
}) => {
  const { user } = useAppSelector((state) => state.auth);
  try {
    if (user.codigoGrupoUsuario === 1) {
      return children;
    }
  } catch (error) {
    console.error('Erro ao parsear dados do usuário:', error);
  }
  return <Navigate to="/" replace />;
};

const AppLayout = () => {
  const location = useLocation();

  const pageTitle = useMemo(() => {
    const path = location.pathname;

    switch (path) {
      case '/':
        return '';
      case '/cadastros/usuario':
        return 'Cadastro de Usuários';
      case '/cadastros/ocorrencia':
        return 'Cadastro de Ocorrências';
      case '/cadastros/notas':
        return 'Cadastro de Notas';
      case '/relatorios/entregas':
        return 'Relatórios';
      case '/documentacao':
        return 'Documentação';
      default:
        return 'SmartEntrega';
    }
  }, [location.pathname]);

  return (
    <Layout pageTitle={pageTitle}>
      <Outlet />
    </Layout>
  );
};

const AppRoutes = () => {
  return (
    <>
      <Loading />
      <Dialog />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/cadastros/usuario" element={<CadastrosUsuario />} />
            <Route
              path="/cadastros/ocorrencia"
              element={<CadastrosOcorrencia />}
            />
            <Route path="/cadastros/notas" element={<CadastrosNotas />} />
            <Route path="/relatorios/entregas" element={<RelatoriosEntregas />} />
            <Route path="/relatorios/entregadores" element={<RelatoriosEntregadoresContainer />} />
            <Route
              path="/documentacao"
              element={
                <ProtectedAdminRoute>
                  <Documentacao />
                </ProtectedAdminRoute>
              }
            />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default AppRoutes;
